import {
    Button,
    Container,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
    Segment,
    SegmentContent,
} from '@/platform/ui';
import { useForm, usePage } from '@inertiajs/react';
import { Editor } from '@tinymce/tinymce-react';

const CreateOrUpdateView = () => {
    const { contract, content, template } = usePage().props;
    const { data, setData, post, processing } = useForm({
        content: content || '',
        template,
    });

    const handleSubmit = () => {
        post(`/contracts/${contract.id}/contents`, {
            onSuccess: () => window.history.back(),
        });
    };

    return (
        <Container>
            <Modal open={true} onClose={() => window.history.back()}>
                <ModalHeader>Contract content</ModalHeader>
                <ModalContent>
                    <Editor
                        apiKey={import.meta.env.VITE_TINYMCE_API_KEY}
                        value={data?.content || ''}
                        init={{
                            height: 500,
                            menubar: false,
                            paste_as_text: true,
                            plugins: ['lists', 'advlist'],
                            toolbar:
                                'undo redo | bold italic underline | bullist numlist | blocks fontsize | forecolor backcolor | alignleft aligncenter alignright alignjustify',
                        }}
                        onEditorChange={content => setData('content', content)}
                    />
                </ModalContent>
                <ModalActions>
                    <Button onClick={() => window.history.back()} type='button'>
                        Annuleren
                    </Button>
                    <Button
                        variant='primary'
                        onClick={handleSubmit}
                        type='button'
                        loading={processing}
                    >
                        Opslaan
                    </Button>
                </ModalActions>
            </Modal>

            <Segment>
                <SegmentContent />
            </Segment>
        </Container>
    );
};

export default CreateOrUpdateView;
